import { render, staticRenderFns } from "./accordionComponent.vue?vue&type=template&id=30f08f1c&scoped=true"
import script from "./accordionComponent.vue?vue&type=script&lang=js"
export * from "./accordionComponent.vue?vue&type=script&lang=js"
import style0 from "./accordionComponent.vue?vue&type=style&index=0&id=30f08f1c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f08f1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\new-tis\\FR-TISSOT-IFB-Discovery-SFCC\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30f08f1c')) {
      api.createRecord('30f08f1c', component.options)
    } else {
      api.reload('30f08f1c', component.options)
    }
    module.hot.accept("./accordionComponent.vue?vue&type=template&id=30f08f1c&scoped=true", function () {
      api.rerender('30f08f1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "cartridges/int_guidedProductFinder/cartridge/client/default/js/components/accordion/accordionComponent.vue"
export default component.exports